import * as API from "apis";
import { SecureLocalStorage } from "helpers";
import {
  setPunchCardsCopy,
  updatePunchCardCopy,
  addPunchCardCopy,
} from "./appifyActions";
import { privateFetch, privateFetchWithToken } from "apis";
import queryString from "query-string";

// action dispatchers
export const setPunchCards = (cards) => ({
  type: "SET_PUNCH_CARDS",
  cards,
});

export const removePunchCards = () => ({
  type: "REMOVE_PUNCH_CARDS",
});

export const removePunchCard = (card) => ({
  type: "REMOVE_PUNCH_CARD",
  card,
});

export const removeTempPunchCard = () => ({
  type: "REMOVE_TEMP_PUNCH_CARD",
});

export const updatePunchCard = (card) => ({
  type: "UPDATE_PUNCH_CARD",
  card,
});

export const addTempPunchCard = () => ({
  type: "ADD_TEMP_PUNCH_CARD",
});

export const updateTempPunchCard = (card) => ({
  type: "UPDATE_TEMP_PUNCH_CARD",
  card,
});

// GET all punchCards associated with an appID
export const getPunchCards = (appId, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/appPunchcards/${appId}`;

  if (accessToken) {
    // console.log("fetching punchcards with access token: " + accessToken);
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  return privateFetch(url, {
    method: "GET",
  }).then((cards) => {
    dispatch(setPunchCards(cards));
    dispatch(setPunchCardsCopy(cards));
    return cards;
  });
};

// create a punchcard
export const createPunchCard = (card) => async (dispatch) => {
  // const defaultCard = {
  //   title: "Punch Card",
  //   numberOfUses: 10,
  // };
  // console.log("Creating PUNCH CARD");
  const newCard = await postPunchCard(card);
  dispatch(updateTempPunchCard(newCard));
  dispatch(addPunchCardCopy(newCard));
  return newCard;
};

const postPunchCard = (card) => {
  const queryParams = queryString.stringify(card);
  const url = __BASE_API_URL__ + `/punchcard?${queryParams}`;

  return privateFetch(url, {
    method: "POST",
  }).then((card) => {
    return card;
  });
};

// export const getPunchCard = (appId) => async (dispatch) => {
//   const punchCards = await API.getAppPunchCards(appId);
//   if (punchCards.length !== 0) {
//     const lastPunchCard = punchCards[punchCards.length - 1];
//     if (!lastPunchCard.retired) {
//       dispatch(setPunchCard(lastPunchCard));
//       dispatch(setPunchCardCopy(lastPunchCard));
//     }
//   }
// };

// export const putPunchCard = (card) => async (dispatch) => {
//   const punchCard = await API.updatePunchCard(card);
//   dispatch(updatePunchCard(punchCard));
//   dispatch(setPunchCardCopy(punchCard));
// };

export const deletePunchCard = (card) => (dispatch) => {
  // console.log("DELETING PUNCHCARD");
  const url = __BASE_API_URL__ + `/punchcard/${card.id}`;

  return privateFetch(url, {
    method: "DELETE",
  }).then((res) => {
    if (res) {
      const newPunchCard = Object.assign({}, card);
      newPunchCard.retired = 1;
      dispatch(updatePunchCard(newPunchCard));
      dispatch(updatePunchCardCopy(newPunchCard));
    }
  });
  // const punchCard = await API.deletePunchCard(id);
  // dispatch(removePunchCard(punchCard));
  // dispatch(setPunchCardCopy({}));
};
